import {
  Add,
  AddCircleOutline,
  ArrowBack,
  ArrowDropDown,
  CachedOutlined,
  Close,
  ContentCopy,
  CurrencyExchangeOutlined,
  DeleteOutlined,
  DirectionsCarFilledOutlined,
  ExpandLess,
  ExpandMore,
  FilterList,
  GridOn,
  HowToRegOutlined,
  InfoOutlined,
  KeyboardReturn,
  LockOutlined,
  MoreVert,
  OpenInNew,
  Print,
  Repeat,
  Search,
  SearchOff,
  Send,
  UnfoldMore,
  CloudSyncOutlined,
  CloudDoneOutlined,
  WarningAmber,
  CloudOffOutlined,
  EditOutlined,
  FileDownloadOutlined,
} from '@mui/icons-material';
import buildIconComponent from './iconHOF.tsx';

export const AddCircleOutlinedIcon = buildIconComponent(AddCircleOutline);
export const AddIcon = buildIconComponent(Add);
export const ArrowBackIcon = buildIconComponent(ArrowBack);
export const ArrowDropDownIcon = buildIconComponent(ArrowDropDown);
export const CloseIcon = buildIconComponent(Close);
export const ContentCopyIcon = buildIconComponent(ContentCopy);
export const DirectionsCarFilledOutlinedIcon = buildIconComponent(
  DirectionsCarFilledOutlined,
);
export const DeleteOutlinedIcon = buildIconComponent(DeleteOutlined);
export const FilterListIcon = buildIconComponent(FilterList);
export const HowToRegOutlinedIcon = buildIconComponent(HowToRegOutlined);
export const KeyboardReturnIcon = buildIconComponent(KeyboardReturn);
export const LockOutlinedIcon = buildIconComponent(LockOutlined);
export const MoreVertIcon = buildIconComponent(MoreVert);
export const SearchIcon = buildIconComponent(Search);
export const SearchOffIcon = buildIconComponent(SearchOff);
export const UnfoldMoreIcon = buildIconComponent(UnfoldMore);
export const RepeatIcon = buildIconComponent(Repeat);
export const SendIcon = buildIconComponent(Send);
export const OpenInNewIcon = buildIconComponent(OpenInNew);
export const PrintIcon = buildIconComponent(Print);
export const CachedIcon = buildIconComponent(CachedOutlined);
export const ExpandMoreIcon = buildIconComponent(ExpandMore);
export const ExpandLessIcon = buildIconComponent(ExpandLess);
export const InfoOutlinedIcon = buildIconComponent(InfoOutlined);
export const CurrencyExchangeOutlinedIcon = buildIconComponent(
  CurrencyExchangeOutlined,
);
export const CloudSyncOutlinedIcon = buildIconComponent(CloudSyncOutlined);
export const CloudDoneOutlinedIcon = buildIconComponent(CloudDoneOutlined);
export const CloudOffOutlinedIcon = buildIconComponent(CloudOffOutlined);

export const WarningAmberIcon = buildIconComponent(WarningAmber);
export const EditOutlinedIcon = buildIconComponent(EditOutlined);
export const GridOnIcon = buildIconComponent(GridOn);
export const FileDownloadOutlinedIcon =
  buildIconComponent(FileDownloadOutlined);
